var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container",attrs:{"role":"main"}},[_c('h1',{staticClass:"text-center"},[_vm._v("Latest Runs")]),_c('notices',{attrs:{"errors":_vm.errors,"notices":_vm.notices}}),_c('cards',{on:{"error":_vm.onError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }